import {
  Button,
  DatePicker,
  Form,
  Modal,
  ModalProps,
  Radio,
  RadioChangeEvent,
} from "antd";
import React, { useState } from "react";

import CustomNotification from "Component/CustomNotification";
import { ExportCsvType } from "../../../constants/enum";
import classNames from "classnames";
import { exportCsv } from "../../../api/tableSession";
import { handleErrorMessage } from "utils/helper/common";
import moment from "moment";
import { saveAs } from "file-saver";
import styles from "./styles.module.scss";
import { useMutation } from "react-query";
import useNetworkStatus from "hooks/useNetworkStatus";

interface IProps extends ModalProps {
  isVisible?: boolean;
  handleCancel: () => void;
}
const ModalExportCsv = (props: IProps) => {
  const { isVisible, handleCancel } = props;
  const [typeExport, setTypeExport] = useState<ExportCsvType>(
    ExportCsvType.Daily
  );
  const [dateRange, setDateRange] = useState<{
    startDate?: string;
    endDate?: string;
  }>({});
  const exportCsvAction = useMutation(exportCsv);
  const isOnline = useNetworkStatus();

  const handleChangeTypeExport = (e: RadioChangeEvent) => {
    setTypeExport(e.target.value);
  };

  const handleExportCsv = (values: any) => {
    if (!isOnline) {
      CustomNotification({
        type: "error",
        message: "",
        description: "オフライン状態のため、データを集計できません。",
      });
      return;
    }
    exportCsvAction.mutate(
      {
        type: values?.type,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
      },
      {
        onSuccess: async (data) => {
          const blob = new Blob([data], {
            type: "application/octet-stream",
          });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          const fileName =
            values?.type === ExportCsvType.Daily
              ? `${moment().format("YYYY-MM-DD")}.xlsx`
              : `${dateRange?.startDate}-${dateRange.endDate}.xlsx`;
          saveAs(blob, fileName);
          CustomNotification({
            type: "success",
            message: "",
            description: "XLSXのエクスポートに成功しました",
          });
          setTypeExport(ExportCsvType.Daily);
          handleCancel();
        },
        onError: (err) => handleErrorMessage(err),
      }
    );
  };
  return (
    <Modal
      open={isVisible}
      footer={null}
      closable={false}
      className={styles.modalSettingDefault}
      width={500}
      destroyOnClose
      centered
    >
      <div className={styles.modalSettingContainer}>
        <div className={styles.header}>データ集計・XLSX出力</div>

        <Form
          className={styles.formContainer}
          onFinish={handleExportCsv}
          initialValues={{
            type: ExportCsvType.Daily,
          }}
        >
          <Form.Item name="type">
            <Radio.Group
              className={classNames(styles.radioGroup, "radioGroupCommon")}
              onChange={handleChangeTypeExport}
              defaultValue={ExportCsvType.Daily}
            >
              <Radio value={ExportCsvType.Daily}>本日分のデータ</Radio>
              <Radio
                value={ExportCsvType.Date_Range}
                className={classNames(styles.radioTimeRange)}
              >
                期間を指定する
              </Radio>
            </Radio.Group>
          </Form.Item>
          {typeExport === ExportCsvType.Date_Range && (
            <Form.Item
              name="dateRange"
              rules={[{ required: true, message: "No null" }]}
            >
              <DatePicker.RangePicker
                className={styles.timeRangePicker}
                onChange={(dates) => {
                  setDateRange({
                    startDate: moment(dates?.[0]).format("YYYY-MM-DD"),
                    endDate: moment(dates?.[1]).format("YYYY-MM-DD"),
                  });
                }}
                disabledDate={(current) => {
                  // Can not select days after today
                  return current && current > moment().endOf("day");
                }}
              />
            </Form.Item>
          )}
          <div className={styles.btnContainer}>
            <Button
              className={classNames(styles.btn, "btn-default")}
              htmlType="submit"
              disabled={exportCsvAction.isLoading}
            >
              XLSX出力
            </Button>
            <Button
              className={classNames(styles.btn, "btn-default")}
              onClick={() => {
                handleCancel();
                setTypeExport(ExportCsvType.Daily);
              }}
            >
              キャンセル
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};
export default ModalExportCsv;
